import { makeRng } from '../rng';
import { legalActions } from './legal';
import { applyAction } from './reduce';
import { GameState, GameAction } from './types';

export type Policy = (state: GameState, seat: number, actions: GameAction[]) => GameAction;

/** 지금 행동이 필요한 자리들. */
export function actingSeats(state: GameState): number[] {
  if (state.phase === 'draw' || state.phase === 'discard') return [state.turn];
  if (state.phase === 'response') return state.responders.slice();
  return [];
}

/** 한 판을 종료 상태까지 진행. */
export function playHand(state: GameState, policy: Policy, maxSteps = 1000): GameState {
  let s = state;
  let steps = 0;
  while (s.phase !== 'ended' && steps < maxSteps) {
    steps++;
    const seats = actingSeats(s);
    if (seats.length === 0) break;
    // response 단계는 여러 자리가 대기할 수 있음 — 첫 자리부터 처리
    const seat = seats[0];
    const actions = legalActions(s, seat);
    if (actions.length === 0) {
      // 합법 수 없음(이론상 response에서 발생 불가하지만 방어): 패스 처리
      if (s.phase === 'response') { s = applyAction(s, { type: 'pass', player: seat }); continue; }
      break;
    }
    const choice = policy(s, seat, actions);
    s = applyAction(s, choice);
  }
  return s;
}

/** 합법 수 중 시드 기반 선택. 화료 가능하면 항상 화료. */
export function randomPolicy(seed: string): Policy {
  const rng = makeRng(seed);
  return (_state, _seat, actions) => {
    const win = actions.find((a) => a.type === 'tsumo' || a.type === 'ron');
    if (win) return win;
    // response에서 화료 안 하면 패스
    const pass = actions.find((a) => a.type === 'pass');
    if (pass && actions.every((a) => a.type === 'pass')) return pass;
    const idx = Math.floor(rng() * actions.length);
    return actions[idx];
  };
}
